import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {
  extractApiError,
  extractApiErrorMessage,
  extractValidationErrors,
} from '../utils/api-error.utils';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlerService {
  constructor(private toastr: ToastrService) {}

  show(err: HttpErrorResponse, title = 'Error'): void {
    this.toastr.error(this.getMessage(err), title);
  }

  getMessage(
    err: HttpErrorResponse,
    fallback = 'Ocurrió un error inesperado'
  ): string {
    return extractApiErrorMessage(err, fallback);
  }

  getValidationErrors(
    err: HttpErrorResponse
  ): Record<string, string[]> | null {
    return extractValidationErrors(err);
  }

  getError(err: HttpErrorResponse) {
    return extractApiError(err);
  }
}
